<template>
  <v-hover>
    <v-card :dark="dark" :color="color" :to="to" slot-scope="{ hover }" :elevation="hover ? 12 : 2" :class="{'card-hover' : hover}">
      <v-layout>
        <v-flex class="pt-20" sm4>
          <v-btn :ripple="false" :class="[ hover ? 'elevation-4' : 'elevation-2']" fab large :color="_iconBgColor" class="btn-icon">
            <v-icon :color="_iconColor" large>{{ icon }}</v-icon>
          </v-btn>
        </v-flex>
        <v-flex class="d-flex align-center justify-center text-xs-center pr-3">
          <div class="title font-weight-regular transition text-xs-left">{{ title }}</div>
        </v-flex>
      </v-layout>
    </v-card>
  </v-hover>
</template>

<script>
  export default {
    props: {
      to: [String, Object],
      icon: String,
      iconColor: String,
      color: {
        type: String,
        default: null,
      },
      iconBgColor: {
        type: String,
        default: null,
      },
      dark: {
        type: Boolean,
        default: false,
      },
      title: String,
    },
    computed: {
      _iconBgColor() {
        if (this.iconBgColor) return this.iconBgColor
        return this.dark ? 'white' : 'secondary'
      },
      _iconColor() {
        if (this.iconColor) return this.iconColor
        return this.dark ? this.color : 'white'
      },
    },
  }
</script>

<style scoped>
  .btn-icon {
    border-radius: 15% !important;
  }

  .pt-20 {
    position: relative;
    top: -20px;
  }
</style>